import type { ModuleRoute } from '../util'
import { mixinParams } from '../util'
import { USER_MANAGE_TYPE, USER_TEACHER_TYPE } from '@/views/teacher/user/constant'

export const userManagerRouteMap = {
  // v2
  30101: {
    path: 'v2/teacher',
    name: 'UserTeacherManage',
    component: () => import('@/views/teacher/user/UserManagePage.vue'),
    props: {
      type: USER_TEACHER_TYPE.enums.Manage.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30100, 30101],
      moduleChildren: [],
    },
  },
  // v3
  30301: {
    path: 'teacher',
    name: 'TeacherManage',
    component: () => import('@/views/teacher/user/UserManagePage.vue'),
    props: {
      type: USER_MANAGE_TYPE.enums.TeacherManage.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30100, 30301],
      moduleChildren: [],
    },
  },
  30201: {
    path: 'student',
    name: 'StudentManage',
    component: () => import('@/views/teacher/user/UserManagePage.vue'),
    props: {
      type: USER_MANAGE_TYPE.enums.StudentManage.value,
    },
    meta: {
      requiresAuth: true,
      roleManager: true,
      modulePath: [30100, 30201],
      moduleChildren: [],
    },
  },
}
mixinParams({ ...userManagerRouteMap }, { moduleName: 'user' })

export default {
  path: '/:symbol([A-Za-z]+)/manager/:module(user)/',
  component: () => import('@/components/teacher/layout/ManagerPageLayout.vue'),
  children: Object.values(userManagerRouteMap as ModuleRoute),
}
